import React from 'react'
import {JSONFetcher, gaEvent, findApiV4Link} from 'shared'
import {Controls} from 'fepp'

export class News extends React.Component {
  state = {}

  componentDidMount() {
    this.loadPage(1)
  }

  // Paginate less on mobile?
  loadPage = (page) => {
    const url = findApiV4Link({ofObject: this.props.fundraisingEvent, withRel: 'blog_posts'}) + `?per_page=1&page=${page}&order=created_at:desc`
    JSONFetcher.load({ url: url, success: response => this.setState(response)})
  }

  loadNextPage = () => {
    this.loadPage(this.state.current_page + 1)
    gaEvent('navigation', 'click news_arrow_right_button', `to_page ${this.state.current_page + 1}`)
  }

  loadPreviousPage = () => {
    this.loadPage(this.state.current_page - 1)
    gaEvent('navigation', 'click new_arrows_left_button', `to_page ${this.state.current_page - 1}`)
  }

  render() {
    // Hide if still loading
    if (this.state.total_entries === undefined) return null

    return <div className="fundraising-events-show-news has-generic-scroll-down-button" id="news">
      <div className="container">
        <div style={{minHeight: 130}} className="has-reloaded-content">
          <div className="row fundraising-events-news-recent">
            <div className="col-md-24 text-center">
              <h1 className="font-lg">{I18n.t('fundraising_events.news.recent.headline')}</h1>

              <Controls
                total={this.state.total_pages}
                current={this.state.current_page}
                loadNextPage={this.loadNextPage}
                loadPreviousPage={this.loadPreviousPage}
              />

            </div>
            <div className="news-recent news-controller col-md-24">
              {this.state.total_entries == 0 ? <NoResult /> : <Expanded blog={this.state.data[0]} />}
            </div>
          </div>
        </div>

        <a className="generic-scroll-down-button" onClick={(event) => {
          event.preventDefault()
          gaEvent('engagement', 'click down_arrow', 'from news to forwarding summary')
          document.querySelector('#forwardings').scrollIntoView({behavior: 'smooth'})
        }} href="#forwardings" />
      </div>
    </div>
  }
}

const NoResult = () => {
  return <div className="generic-no-results text-center">
    <p><strong>{I18n.t('news.no_results.notice')}</strong></p>
  </div>
}

const Expanded = ({blog}) => {
  const url = findApiV4Link({ofObject: blog, withRel: 'platform'})
  const authorName = blog.author ? blog.author.name : ''
  const authorImage = blog.author ? findApiV4Link({ofObject: blog.author.picture, withRel: 'fill_100x100'}) : ''

  return <div className="news-expanded-blog-container p-b-md">
    <div className="row">
      <div className="col-md-18 offset-md-3">
        <div className="news-linked-blog">
          <a href={url}>
            <h1 className="m-t-0 m-b font-lg">{blog.title}</h1>
          </a>
          <div className="news-blog-body">
            <div className="media m-t-0 m-b-md">
              <div className="media-left media-middle">
                <img className="user-avatar round-image" src={authorImage} width="50" height="50" />
              </div>
              <div className="media-body media-middle">
                {I18n.t('news.news_helper.blog_details_html', {author: authorName, created_at: I18n.l('date.formats.default2', blog.created_at)})}
              </div>
            </div>
            <div className="font-big-text">
              <div className="trix-content" dangerouslySetInnerHTML={{ __html: blog.body }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
